import { useMutation } from '@tanstack/react-query';
import { retentionAdminApi } from '../api/retentionAdminApi';

/**
 * POST /api/eraf/retention-admin/policies/{id}/dry-run — 미리보기 비파괴 (RETENTION_READ)
 */
export function useDryRun() {
  return useMutation({
    mutationFn: (id: number) => retentionAdminApi.dryRun(id),
  });
}
